import { ReactNode } from 'react';

interface AnimatedTitleProps {
  children: ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
  size?: 'sm' | 'md' | 'lg';
  highlightColor?: string;
}

export function AnimatedTitle({
  children,
  className = '',
  align = 'center',
  size = 'md',
  highlightColor = 'bg-yellow-400'
}: AnimatedTitleProps) {
  const alignClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }[align];
  
  const sizeClass = {
    sm: 'text-xl md:text-2xl',
    md: 'text-2xl md:text-3xl',
    lg: 'text-3xl md:text-4xl'
  }[size];
  
  return (
    <div className={`${alignClass} relative w-fit mx-auto ${className}`}>
      <h2 className={`${sizeClass} font-bold group transition-all duration-300 relative inline-block`}>
        {children}
        <span className={`absolute bottom-0 left-0 w-0 h-1 ${highlightColor} group-hover:w-full transition-all duration-300`}></span>
      </h2>
    </div>
  );
}

export function AnimatedTitleWithDescription({
  title,
  description,
  className = '',
  align = 'center',
  size = 'md',
  highlightColor = 'bg-yellow-400'
}: {
  title: ReactNode;
  description?: ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
  size?: 'sm' | 'md' | 'lg';
  highlightColor?: string;
}) {
  const alignClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }[align];
  
  return (
    <div className={`${alignClass} mb-12 ${className}`}>
      <AnimatedTitle align={align} size={size} highlightColor={highlightColor}>
        {title}
      </AnimatedTitle>
      {description && (
        <p className="text-gray-600 max-w-2xl mx-auto mt-4">
          {description}
        </p>
      )}
    </div>
  );
} 